import { Popover } from 'antd';
import React, { type PropsWithChildren, useState } from 'react';
import { type IDynamicProperty } from 'stores/DynamicProperties/IDynamicProperty';

import PropertyPopoverContent from './PropertyPopoverContent';

export type PropertyPopoverProps = PropsWithChildren<{
    property: IDynamicProperty<any>;
    editMode: boolean;
}>;

function PropertyPopover({
    property,
    editMode,
    children,
}: PropertyPopoverProps) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    return (
        <Popover
            title={property.name}
            open={isPopoverOpen}
            onOpenChange={setIsPopoverOpen}
            trigger="hover"
            content={
                <PropertyPopoverContent
                    property={property}
                    editMode={editMode}
                    onDismiss={() => setIsPopoverOpen(false)}
                />
            }
        >
            {children}
        </Popover>
    );
}

// Not an observer, deliberately. `observer` earns its keep when a component
// reads an observable *during render* and has to re-render when that value
// changes. Nothing here does: isPopoverOpen is useState, editMode and children
// arrive as props, and DynamicProperty never calls becomeObservable, so
// property.name is a plain field rather than a tracked one.
//
// Dropping it also drops the React.memo that observer wraps function components
// in, so this now re-renders whenever its parent does - more often than before,
// never less. Nothing downstream can go stale as a result.
export default PropertyPopover;
